module.exports = __webpack_public_path__ + "b799a90a0226ae650b181668dbbd52e2.pdf";